import { useQuery } from "react-query";
import {
  getConversationList,
  getConversationDetail,
  getAiUnitBalance,
} from "../../../services/aiChat";

export const useGetConversationList = ({ isEnabled = true } = {}) => {
  return useQuery(
    ["aiConversationList"],
    () => getConversationList().then((res) => res?.data?.data),
    {
      enabled: isEnabled,
      staleTime: Infinity,
      refetchOnWindowFocus: false,
    },
  );
};

export const useGetAiUnitBalance = ({ isEnabled = true } = {}) => {
  return useQuery(
    ["aiUnitBalance"],
    () => getAiUnitBalance().then((res) => res?.data?.data),
    {
      enabled: isEnabled,
      // Units are metered per turn, so the balance is only ever refetched
      // explicitly — never cached across sessions and never polled.
      staleTime: 0,
      cacheTime: 0,
      // Covers coming back to the app after a top up.
      refetchOnWindowFocus: true,
      retry: 1,
    },
  );
};

export const useGetConversationDetail = ({ id, isEnabled = true }) => {
  return useQuery(
    ["aiConversationDetail", id],
    () => getConversationDetail(id).then((res) => res?.data?.data),
    {
      enabled: isEnabled && !!id,
      staleTime: Infinity,
      refetchOnWindowFocus: false,
    },
  );
};
